// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#canvasDraw {
   border: 1px solid rgb(204, 203, 203);
   cursor: pointer;
   margin-top: 5px;
}

.form{
   width: 545px!important;
   max-width: 550px;
   height: auto;
}
.tab-container {
   height: 270px;
   min-height: 270px!important;
   padding-top: 10px;
}

::ng-deep .mat-tab-label
{
   display: flex;
   flex: 1;
}

::ng-deep .mat-dialog-content {
   display: block;
   margin: 0 -24px;
   padding: 0 24px;
   max-height: 65vh;
   overflow-y: auto!important;
}

.pattern {
   overflow: auto;
   padding-left: 15px;
}

.btn-upload {
   margin-top: -5px;
   margin-left: -40px;
   margin-bottom: 35px;
}

.btn-clear {
   margin-top: 5px;
}

.li-filesize {
   padding-top: 15px;
}

.menu {
   list-style: none;
}

.menu > li {
   float: left;
}

.menu > li + li {
   margin-left: 1em;
}

.menu > li > a {
   border: 1px solid #bdc3c7;
   border-radius: 2px;
   cursor: pointer;
   display: block;
   padding: 5px 1em;
   white-space: nowrap;
}

.menu > li > a:hover {
   background-color: #f7f7f7;
   color: #3d464d;
   text-decoration: none;
}

.menu > li > a > i {
   font-size: 16px;
   margin-right: 10px;
}

.menu button {
   padding: 0 12px;
}

.menu button.mat-primary {
   line-height: 30px;
}

.menu button:not(.mat-primary) {
   border: 1px solid #bdc3c7;
   line-height: 28px;
}

.menu button i {
   font-size: 16px;
   margin-right: 10px;
}

.separator {
   border: none;
   border-top: 1px solid #eaeaea;
   height: 0;
   margin: 5px 0;
}

.toolbar .dropdown-menu {
   left: auto;
   right: 0;
}

.file-upload {
   display: none;
   overflow: hidden;
   width: 0;
   height: 0;
}

.input-radio-pattern {
   vertical-align: top;
   margin-top: 20px !important;
   margin-left: 10px !important;
}

.canvas-pattern {
   border: 1px #ccc solid;
   border-radius: 15px;
}

.pt1 {
   font-family: 'calligraffittiregular', sans-serif;
}

.pt2 {
   font-family: 'damionregular', sans-serif;
}

.pt3 {
   font-family: 'dancing_scriptbold', sans-serif;
}

.pt4 {
   font-family: 'great_vibesregular', sans-serif;
}

.pt5 {
   font-family: 'pacificoregular', sans-serif;
}

.pt6 {
   font-family: 'pinyon_scriptregular', sans-serif;
}

.pt7 {
   font-family: 'rock_saltregular', sans-serif;
}

.pt8 {
   font-family: 'waiting_for_the_sunriseRg', sans-serif;
}

.pt9 {
   font-family: 'yellowtailregular', sans-serif;
}

.pt10 {
   font-family: 'sue_ellen_francisco_regular', sans-serif;
}

.pt11 {
   font-family: 'EkkamaiNew_Regular', sans-serif;
}

.pt12 {
   font-family: 'chulabhornlikittext_regular', sans-serif;
}
.pt13 {
   font-family: 'chulabhornlikittext_medium', sans-serif;
}
.pt14 {
   font-family: 'chulabhornlikittext_light', sans-serif;
}

.pattern-radio-group {
   display: inline-flex;
   flex-direction: column;
   width: 350px;
}

.pattern-radio-button {
   margin: 5px 0 5px 0;
}

.pattern-selected-value {
   margin: 15px 0;
}

.fileUpload {
   position: relative;
   overflow: hidden;
   margin: 10px;
}

.fileUpload input.upload {
   position: absolute;
   top: 0;
   right: 0;
   margin: 0;
   padding: 0;
   font-size: 20px;
   cursor: pointer;
   opacity: 0;
   filter: alpha(opacity=0);
}

.ui-dialog {
   position: absolute !important;
}

.signature {
   max-height: 50px;
   max-width: 220px;
}

.error {
   font-size: 13px;
   color: #d32f2f;
   margin: -25px 0 30px;
   padding-bottom: 5px;
 }
.title-sign{
   display: flex;
}
.select-botton{
   border:1px solid #2ab4c0;
}
.buttonSignature {
   padding: 10px;
   width: 235px;
   min-width: 235px!important;
   height: 70px;
   outline: none;
   border:solid 1px #ccc;
   background-color: white!important;
   box-shadow: 0 0 0 2px #2ab4c0;
   overflow:hidden;
   margin-top:20px;
   border-radius:8px;
}
.buttonSignature .buttonInitializeSign img {
   max-height: 50px;
   max-width: 190px;
}
.buttonInitializeSign {
   padding: 10px;
   width: 235px;
   min-width: 235px!important;
   height: 70px;
   outline: none;
   border:solid 1px #ccc;
   background-color: white!important;
   overflow:hidden;
   margin-top:20px;
   margin-left:25px;
   border-radius:8px;
}
[hidden] {
   display: none !important;
}
.inputName{
   position: relative;
   padding-bottom: 15px;
   margin-bottom: -5px;
   width:235px;
}
.inputInitial{
   position: relative;
   padding-bottom: 15px;
   margin-bottom: -5px;
   width:235px;
   margin-left: 25px;
}
.marginInitial{
   margin-top: 10px!important;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/register-signature/register-signature.component.css"],"names":[],"mappings":"AAAA;GACG,oCAAoC;GACpC,eAAe;GACf,eAAe;AAClB;;AAEA;GACG,sBAAsB;GACtB,gBAAgB;GAChB,YAAY;AACf;AACA;GACG,aAAa;GACb,2BAA2B;GAC3B,iBAAiB;AACpB;;AAEA;;GAEG,aAAa;GACb,OAAO;AACV;;AAEA;GACG,cAAc;GACd,eAAe;GACf,eAAe;GACf,gBAAgB;GAChB,0BAA0B;AAC7B;;AAEA;GACG,cAAc;GACd,kBAAkB;AACrB;;AAEA;GACG,gBAAgB;GAChB,kBAAkB;GAClB,mBAAmB;AACtB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,WAAW;AACd;;AAEA;GACG,gBAAgB;AACnB;;AAEA;GACG,yBAAyB;GACzB,kBAAkB;GAClB,eAAe;GACf,cAAc;GACd,gBAAgB;GAChB,mBAAmB;AACtB;;AAEA;GACG,yBAAyB;GACzB,cAAc;GACd,qBAAqB;AACxB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,eAAe;AAClB;;AAEA;GACG,iBAAiB;AACpB;;AAEA;GACG,yBAAyB;GACzB,iBAAiB;AACpB;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,YAAY;GACZ,6BAA6B;GAC7B,SAAS;GACT,aAAa;AAChB;;AAEA;GACG,UAAU;GACV,QAAQ;AACX;;AAEA;GACG,aAAa;GACb,gBAAgB;GAChB,QAAQ;GACR,SAAS;AACZ;;AAEA;GACG,mBAAmB;GACnB,2BAA2B;GAC3B,4BAA4B;AAC/B;;AAEA;GACG,sBAAsB;GACtB,mBAAmB;AACtB;;AAEA;GACG,gDAAgD;AACnD;;AAEA;GACG,wCAAwC;AAC3C;;AAEA;GACG,6CAA6C;AAChD;;AAEA;GACG,6CAA6C;AAChD;;AAEA;GACG,0CAA0C;AAC7C;;AAEA;GACG,+CAA+C;AAClD;;AAEA;GACG,2CAA2C;AAC9C;;AAEA;GACG,oDAAoD;AACvD;;AAEA;GACG,4CAA4C;AAC/C;;AAEA;GACG,sDAAsD;AACzD;;AAEA;GACG,6CAA6C;AAChD;;AAEA;GACG,sDAAsD;AACzD;AACA;GACG,qDAAqD;AACxD;AACA;GACG,oDAAoD;AACvD;;AAEA;GACG,oBAAoB;GACpB,sBAAsB;GACtB,YAAY;AACf;;AAEA;GACG,mBAAmB;AACtB;;AAEA;GACG,cAAc;AACjB;;AAEA;GACG,kBAAkB;GAClB,gBAAgB;GAChB,YAAY;AACf;;AAEA;GACG,kBAAkB;GAClB,MAAM;GACN,QAAQ;GACR,SAAS;GACT,UAAU;GACV,eAAe;GACf,eAAe;GACf,UAAU;GACV,wBAAwB;AAC3B;;AAEA;GACG,6BAA6B;AAChC;;AAEA;GACG,gBAAgB;GAChB,gBAAgB;AACnB;;AAEA;GACG,eAAe;GACf,cAAc;GACd,oBAAoB;GACpB,mBAAmB;CACrB;AACD;GACG,aAAa;AAChB;AACA;GACG,wBAAwB;AAC3B;AACA;GACG,aAAa;GACb,YAAY;GACZ,0BAA0B;GAC1B,YAAY;GACZ,aAAa;GACb,qBAAqB;GACrB,iCAAiC;GACjC,6BAA6B;GAC7B,eAAe;GACf,eAAe;GACf,iBAAiB;AACpB;AACA;GACG,gBAAgB;GAChB,gBAAgB;AACnB;AACA;GACG,aAAa;GACb,YAAY;GACZ,0BAA0B;GAC1B,YAAY;GACZ,aAAa;GACb,qBAAqB;GACrB,iCAAiC;GACjC,eAAe;GACf,eAAe;GACf,gBAAgB;GAChB,iBAAiB;AACpB;AACA;GACG,wBAAwB;AAC3B;AACA;GACG,kBAAkB;GAClB,oBAAoB;GACpB,mBAAmB;GACnB,WAAW;AACd;AACA;GACG,kBAAkB;GAClB,oBAAoB;GACpB,mBAAmB;GACnB,WAAW;GACX,iBAAiB;AACpB;AACA;GACG,0BAA0B;AAC7B","sourcesContent":["#canvasDraw {\n   border: 1px solid rgb(204, 203, 203);\n   cursor: pointer;\n   margin-top: 5px;\n}\n\n.form{\n   width: 545px!important;\n   max-width: 550px;\n   height: auto;\n}\n.tab-container {\n   height: 270px;\n   min-height: 270px!important;\n   padding-top: 10px;\n}\n\n::ng-deep .mat-tab-label\n{\n   display: flex;\n   flex: 1;\n}\n\n::ng-deep .mat-dialog-content {\n   display: block;\n   margin: 0 -24px;\n   padding: 0 24px;\n   max-height: 65vh;\n   overflow-y: auto!important;\n}\n\n.pattern {\n   overflow: auto;\n   padding-left: 15px;\n}\n\n.btn-upload {\n   margin-top: -5px;\n   margin-left: -40px;\n   margin-bottom: 35px;\n}\n\n.btn-clear {\n   margin-top: 5px;\n}\n\n.li-filesize {\n   padding-top: 15px;\n}\n\n.menu {\n   list-style: none;\n}\n\n.menu > li {\n   float: left;\n}\n\n.menu > li + li {\n   margin-left: 1em;\n}\n\n.menu > li > a {\n   border: 1px solid #bdc3c7;\n   border-radius: 2px;\n   cursor: pointer;\n   display: block;\n   padding: 5px 1em;\n   white-space: nowrap;\n}\n\n.menu > li > a:hover {\n   background-color: #f7f7f7;\n   color: #3d464d;\n   text-decoration: none;\n}\n\n.menu > li > a > i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.menu button {\n   padding: 0 12px;\n}\n\n.menu button.mat-primary {\n   line-height: 30px;\n}\n\n.menu button:not(.mat-primary) {\n   border: 1px solid #bdc3c7;\n   line-height: 28px;\n}\n\n.menu button i {\n   font-size: 16px;\n   margin-right: 10px;\n}\n\n.separator {\n   border: none;\n   border-top: 1px solid #eaeaea;\n   height: 0;\n   margin: 5px 0;\n}\n\n.toolbar .dropdown-menu {\n   left: auto;\n   right: 0;\n}\n\n.file-upload {\n   display: none;\n   overflow: hidden;\n   width: 0;\n   height: 0;\n}\n\n.input-radio-pattern {\n   vertical-align: top;\n   margin-top: 20px !important;\n   margin-left: 10px !important;\n}\n\n.canvas-pattern {\n   border: 1px #ccc solid;\n   border-radius: 15px;\n}\n\n.pt1 {\n   font-family: 'calligraffittiregular', sans-serif;\n}\n\n.pt2 {\n   font-family: 'damionregular', sans-serif;\n}\n\n.pt3 {\n   font-family: 'dancing_scriptbold', sans-serif;\n}\n\n.pt4 {\n   font-family: 'great_vibesregular', sans-serif;\n}\n\n.pt5 {\n   font-family: 'pacificoregular', sans-serif;\n}\n\n.pt6 {\n   font-family: 'pinyon_scriptregular', sans-serif;\n}\n\n.pt7 {\n   font-family: 'rock_saltregular', sans-serif;\n}\n\n.pt8 {\n   font-family: 'waiting_for_the_sunriseRg', sans-serif;\n}\n\n.pt9 {\n   font-family: 'yellowtailregular', sans-serif;\n}\n\n.pt10 {\n   font-family: 'sue_ellen_francisco_regular', sans-serif;\n}\n\n.pt11 {\n   font-family: 'EkkamaiNew_Regular', sans-serif;\n}\n\n.pt12 {\n   font-family: 'chulabhornlikittext_regular', sans-serif;\n}\n.pt13 {\n   font-family: 'chulabhornlikittext_medium', sans-serif;\n}\n.pt14 {\n   font-family: 'chulabhornlikittext_light', sans-serif;\n}\n\n.pattern-radio-group {\n   display: inline-flex;\n   flex-direction: column;\n   width: 350px;\n}\n\n.pattern-radio-button {\n   margin: 5px 0 5px 0;\n}\n\n.pattern-selected-value {\n   margin: 15px 0;\n}\n\n.fileUpload {\n   position: relative;\n   overflow: hidden;\n   margin: 10px;\n}\n\n.fileUpload input.upload {\n   position: absolute;\n   top: 0;\n   right: 0;\n   margin: 0;\n   padding: 0;\n   font-size: 20px;\n   cursor: pointer;\n   opacity: 0;\n   filter: alpha(opacity=0);\n}\n\n.ui-dialog {\n   position: absolute !important;\n}\n\n.signature {\n   max-height: 50px;\n   max-width: 220px;\n}\n\n.error {\n   font-size: 13px;\n   color: #d32f2f;\n   margin: -25px 0 30px;\n   padding-bottom: 5px;\n }\n.title-sign{\n   display: flex;\n}\n.select-botton{\n   border:1px solid #2ab4c0;\n}\n.buttonSignature {\n   padding: 10px;\n   width: 235px;\n   min-width: 235px!important;\n   height: 70px;\n   outline: none;\n   border:solid 1px #ccc;\n   background-color: white!important;\n   box-shadow: 0 0 0 2px #2ab4c0;\n   overflow:hidden;\n   margin-top:20px;\n   border-radius:8px;\n}\n.buttonSignature .buttonInitializeSign img {\n   max-height: 50px;\n   max-width: 190px;\n}\n.buttonInitializeSign {\n   padding: 10px;\n   width: 235px;\n   min-width: 235px!important;\n   height: 70px;\n   outline: none;\n   border:solid 1px #ccc;\n   background-color: white!important;\n   overflow:hidden;\n   margin-top:20px;\n   margin-left:25px;\n   border-radius:8px;\n}\n[hidden] {\n   display: none !important;\n}\n.inputName{\n   position: relative;\n   padding-bottom: 15px;\n   margin-bottom: -5px;\n   width:235px;\n}\n.inputInitial{\n   position: relative;\n   padding-bottom: 15px;\n   margin-bottom: -5px;\n   width:235px;\n   margin-left: 25px;\n}\n.marginInitial{\n   margin-top: 10px!important;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
